import { render, staticRenderFns } from "./industrial-distribution.vue?vue&type=template&id=4db1849f&"
import script from "./industrial-distribution.vue?vue&type=script&lang=js&"
export * from "./industrial-distribution.vue?vue&type=script&lang=js&"
import style0 from "./industrial-distribution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports